import Vue from 'vue';
import NoLayout from '@/views/layouts/nolayout/';
import DefaultLayout from '@/views/layouts/default/';
import VueTreeselect from '@riophae/vue-treeselect'

Vue.component('DefaultLayout', DefaultLayout);
Vue.component('NoLayout', NoLayout);
Vue.component('treeselect', VueTreeselect.Treeselect)
